import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyAnimatedIconContainer = () => {
  return <PropertyDetail type="animated-icon" />;
};

export default PropertyAnimatedIconContainer;
